import React, { useState, useEffect } from "react";
import Modal from "components/modal";
import angle_down from "assets/images/arrowdown.svg";
import angle_up from "assets/images/arrowup.svg";
import filter from "assets/images/filter.svg";
import close from "assets/images/close.svg";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: any) => void;
}

export default function FilterModal({ onClose, isOpen, onApply }: Props) {
  const [isVaccineOpen, setIsVaccineOpen] = useState(false);
  const [isAgeOpen, setIsAgeOpen] = useState(false);
  const [isSexOpen, setIsSexOpen] = useState(false);
  const [isLocationOpen, setIsLocationOpen] = useState(false);

  const [selectedFilters, setSelectedFilters] = useState({
    vaccineType: "",
    ageGroup: "",
    sex: "",
    location: "",
  });

  useEffect(() => {
    if (!isOpen) {
      setSelectedFilters({
        vaccineType: "",
        ageGroup: "",
        sex: "",
        location: "",
      });
      setIsVaccineOpen(false);
      setIsAgeOpen(false);
      setIsSexOpen(false);
      setIsLocationOpen(false);
    }
  }, [isOpen]);

  const handleSelect = (category: string, value: string) => {
    setSelectedFilters((prev) => ({ ...prev, [category]: value }));
  };

  const handleApply = () => {
    onApply(selectedFilters);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="rounded-lg bg-white shadow-xl w-[95%] md:w-[44%] mx-4 flex-col p-4 h-[80%] md:h-[55%] flex items-center justify-between">
        <div className="flex-col w-full flex items-center justify-start">
          <div className="w-full pt-2 pb-5 flex items-start justify-between">
            <h1 className="text-[14px] md:text-[16px]">Filter</h1>
            <button onClick={onClose}>
              <img src={close} alt="Close" className="w-5 h-5" />
            </button>
          </div>

          <div className="w-[100%] flex items-center justify-between">
            <div className="relative">
              <button
                className="flex items-center justify-between rounded-3xl gap-2 border border-black px-2 py-1 cursor-pointer"
                onClick={() => setIsVaccineOpen(!isVaccineOpen)}
              >
                <img src={filter} alt="" className="md:flex hidden" />
                <p className="text-[12px]">
                  {selectedFilters.vaccineType || "Vaccine Type"}
                </p>
                <img
                  className="md:flex hidden"
                  src={isVaccineOpen ? angle_up : angle_down}
                  alt="Toggle Arrow"
                />
              </button>

              {isVaccineOpen && (
                <div className="absolute top-[45px] left-0 w-[180px] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <ul className="flex flex-col">
                    {["Option 1", "Option 2", "Option 3"].map((option) => (
                      <li
                        key={option}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          handleSelect("vaccineType", option);
                          setIsVaccineOpen(false);
                        }}
                      >
                        {option}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                className="flex items-center justify-between rounded-3xl gap-2 border border-black px-2 py-1 cursor-pointer"
                onClick={() => setIsAgeOpen(!isAgeOpen)}
              >
                <img src={filter} alt="" className="md:flex hidden" />
                <p className="text-[12px]">
                  {selectedFilters.ageGroup || "Age Group"}
                </p>
                <img
                  className="md:flex hidden"
                  src={isAgeOpen ? angle_up : angle_down}
                  alt="Toggle Arrow"
                />
              </button>

              {isAgeOpen && (
                <div className="absolute top-[45px] left-0 w-[180px] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <ul className="flex flex-col">
                    {["0 - 5 years", "6 - 12 years", "13 - 18 years"].map(
                      (age) => (
                        <li
                          key={age}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onClick={() => {
                            handleSelect("ageGroup", age);
                            setIsAgeOpen(false);
                          }}
                        >
                          {age}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                className="flex items-center justify-between rounded-3xl gap-2 border border-black px-2 py-1 cursor-pointer"
                onClick={() => setIsSexOpen(!isSexOpen)}
              >
                <img src={filter} alt="" className="md:flex hidden" />
                <p className="text-[12px]">{selectedFilters.sex || "Sex"}</p>
                <img
                  className="md:flex hidden"
                  src={isSexOpen ? angle_up : angle_down}
                  alt="Toggle Arrow"
                />
              </button>

              {isSexOpen && (
                <div className="absolute top-[45px] left-0 w-[180px] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <ul className="flex flex-col">
                    {["Male", "Female", "Other"].map((sex) => (
                      <li
                        key={sex}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          handleSelect("sex", sex);
                          setIsSexOpen(false);
                        }}
                      >
                        {sex}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                className="flex items-center justify-between rounded-3xl gap-2 border border-black px-2 py-1 cursor-pointer"
                onClick={() => setIsLocationOpen(!isLocationOpen)}
              >
                <img src={filter} alt="" className="md:flex hidden" />
                <p className="text-[12px]">
                  {selectedFilters.location || "Location"}
                </p>
                <img
                  className="md:flex hidden"
                  src={isLocationOpen ? angle_up : angle_down}
                  alt="Toggle Arrow"
                />
              </button>

              {isLocationOpen && (
                <div className="absolute top-[45px] left-0 w-[180px] bg-white border border-gray-300 rounded-lg shadow-lg">
                  <ul className="flex flex-col">
                    {["Lagos", "Abuja", "Kaduna"].map((loc) => (
                      <li
                        key={loc}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          handleSelect("location", loc);
                          setIsLocationOpen(false);
                        }}
                      >
                        {loc}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        <button
          className="bg-[#2C9BD7] text-white w-full py-3 rounded-xl"
          onClick={handleApply}
        >
          Apply Filter
        </button>
      </div>
    </Modal>
  );
}
